import ReactSelect from 'react-select';
import styled, { css } from 'styled-components';

import { pxToRem } from 'utils/scss';

const getStyles = props => {
  let style;
  switch (props.variant) {
    case 'login':
      style = css`
        border-right: ${pxToRem('1px')} solid rgba(255, 255, 255, 0.8);
        background-color: transparent;
        width: ${pxToRem('100px')}
        padding: ${pxToRem('8px')} !important;
        
      `;
      break;
    case 'firmware':
      style = css`
        padding: ${pxToRem('16px')};
        height: ${pxToRem('56px')};
      `;
      break;
    default:
      style = css`
        border-color: inherit;
      `;
      break;
  }
  return style;
};

export const SelectWrapper = styled(ReactSelect)`
  border: none;
  font-size: ${pxToRem('12px')};
  min-width: ${props =>
    props.paginationMenu || props.noMinWidth
      ? pxToRem('70')
      : pxToRem('160px')};
  width: 100%;
  height:100%;
  border-radius: inherit;

  
  
  & > div {
    width: 100%;
  }

  & .Select-placeholder {
    color: ${({ theme }) => theme.colors.black};
  }

  & .Select__indicator {
    color: ${({ theme }) => theme.colors.blue.one};
    align-items: baseline;
    padding: ${pxToRem('0px')};
  }
  
  & .Select__indicator-separator {
    display: none;
  }

  & .Select__control {
    background: none;
    border: none;
    // border-color: transparent !important;
    display:flex;
    align-items: center;
    padding: ${pxToRem('16px')} ${pxToRem('32px')};
    flex: 1;
    height: 100%;
    width:100%;
    border-radius: inherit;
    
    ${props => getStyles(props)}
    ${props =>
      props.variant === 'firmware' &&
      css`
        border: 1px solid rgba(70, 122, 251, 0.56) !important;
        border-radius: ${pxToRem('8px')};
      `}

    ${props =>
      props.variant === 'editaccountdata' &&
      css`
        opacity: 0.4;
        border: ${pxToRem('1px')} solid rgba(70, 122, 251, 1);
        padding: ${pxToRem('16px')};
        border-radius: ${pxToRem('8px')};
        ${props =>
          props.value &&
          css`
            opacity: 1;
          `}
      `}
    ${props =>
      props.paginationMenu &&
      css`
        padding: 0 ${pxToRem(8)};
        justify-content: space-around;
        position: unset;
      `}
    :hover{
      cursor: pointer;
    }
    & .Select__indicators{
      padding:0
    }

     & .Select__indicator {
      transition: all 250ms;
    }
  }

  & .Select__value-container {
    position: relative;
    height: 100%;
    width: 80%;
    padding: 0;
    
    ${props =>
      props.variant === 'login' &&
      css`
        font-weight: normal;
      `}
    
    ${props =>
      props.paginationMenu &&
      css`
        position: unset;
        height: initial;
        width: initial;
        flex: initial;
      `}
      & > span {
      font-size: ${pxToRem('12px')};
    }
  }

  & .Select__control--is-focused {
    box-shadow: none;
  }

  & .Select__control--menu-is-open {

    padding: ${props =>
      props.variant !== 'login'
        ? props.variant === 'editaccountdata'
          ? `${pxToRem('16px')}`
          : `${pxToRem('4px')} ${pxToRem('32px')}`
        : `${pxToRem('8px')}`};

      ${props =>
        props.paginationMenu &&
        css`
          padding: 0 ${pxToRem(8)};
          background-color: white;
          border-top-left-radius: ${pxToRem('24px')};
          border-top-right-radius: ${pxToRem('24px')};
        `}

    & .Select__indicator {
      transform: rotate(180deg);
    }

    
  }

  & .Select__value-container--is-multi {
    span{
      margin-right:${pxToRem('5px')};
      max-height: 100%;
    }
  }

  & .Select__value-container--has-value{
    overflow: unset;
    ${props =>
      !props.paginationMenu &&
      !props.hidePlaceholderOnSelection &&
      props.variant !== 'editaccountdata' &&
      css`
        span {
          margin-top: ${pxToRem(14)};
        }
      `}

   
  }

  & .Select__placeholder {
    font-family: OpenSans;
    font-size: ${props => pxToRem(props.fontSize) || pxToRem('12px')};
    font-weight: ${props => props.fontWeight || 'bold'};
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: normal;
    color: #000;
  }

  & .Select__single-value {
    font-family: OpenSans;
    font-size: ${props => pxToRem(props.fontSize) || pxToRem('12px')};
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: right;
    color: #000;
  }

  & .Select__option {
    background-color: white;
    color: black;
    font-family: OpenSans;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    padding-bottom: ${pxToRem('24px')};

    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    &:active{
      background-color: white;
    color: black;
    }


    & > span {
      margin-left: ${pxToRem('8px')};
    }
    ${props =>
      props.paginationMenu &&
      css`
        justify-content: center;
        padding: ${pxToRem('6px')} ${pxToRem('18px')};
        font-family: OpenSans;
        font-size: ${pxToRem('12px')};
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.33;
        letter-spacing: normal;
        color: #000;
        text-align: center;
        & > span {
          margin: 0;
        }
      `}
  

    :hover{
      cursor: pointer;
    }
  }

  & .Select__indicators {
    align-items: center;
    padding: ${pxToRem('5px')};
   

    ${props =>
      props.checkBoxMenu &&
      css`
        justify-content: flex-end;
      `}
  }

  & .Select__container {
    display: flex;
  }

  & .Select__menu {
    z-index:20;
    width: ${props =>
      props.menuWidth ? `${pxToRem(props.menuWidth)}` : '100%'};
    margin: ${pxToRem('0px')};

    border-radius: ${props =>
      props.variant === 'firmware' ? pxToRem('8px') : pxToRem('24px')};
    -webkit-backdrop-filter: blur(${pxToRem('24px')});
    backdrop-filter: blur(${pxToRem('24px')});
    box-shadow: 0 ${pxToRem('15px')} ${pxToRem(
  '20px'
)} 0 rgba(70, 122, 251, 0.16);
    background-color: ${props => props.theme.colors.white};
    padding: ${pxToRem(10)};

    ${props =>
      !props.paginationMenu &&
      css`
        padding: ${pxToRem('24px')};
      `}

    ${props =>
      !props.detachedOptions &&
      css`
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      `}

    ${props =>
      props.detachedOptions &&
      css`
        margin-top: ${pxToRem('16px')};
      `}
    ${props =>
      props.variant === 'login' &&
      css`
        width: 70%;
        border-radius: ${pxToRem('8px')};
        padding: ${pxToRem('10px')};

        .Select__option {
          padding-right: 0;
          padding-left: 0;
        }
      `}
    ${props =>
      props.variant === 'editaccountdata' &&
      css`
        width: inherit;
        border-radius: ${pxToRem('8px')};
        padding: ${pxToRem('10px')};

        .Select__option {
          padding-right: 0;
          padding-left: 0;
        }
      `}
  }
`;

export const OptionContainer = styled.div`
  display: flex;
  flex-container: row;
`;

export const UpArrow = styled.div`
  border: solid #467afb;
  border-width: 0 ${pxToRem('3px')} ${pxToRem('3px')} 0;
  display: inline-block;
  padding: ${pxToRem('3px')};
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
`;

export const DownArrow = styled.div`
  border: solid #467afb;
  border-width: 0 ${pxToRem('3px')} ${pxToRem('3px')} 0;
  display: inline-block;
  padding: ${pxToRem('3px')};
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
`;

export const ArrowContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Placeholder = styled.div`
  ${props =>
    props.hasValue
      ? props.hide
        ? css`
            display: none;
          `
        : props.variant !== 'editaccountdata'
        ? css`
            transform: scale(0.8) translateX(-${pxToRem('5px')})
              translateY(-${pxToRem('22px')});
            position: absolute;
            transition: all 500ms;
            color: #919397;
            font-weight: 600;
          `
        : css`
            transform: scale(0.8) translateX(-${pxToRem('0px')})
              translateY(-${pxToRem('33px')});
            position: absolute;
            transition: all 500ms;

            background-color: white;
            padding: 0 ${pxToRem('5px')};

            color: ${props => props.theme.colors.mainBlue};

            & > span {
              font-weight: 600;
            }
          `
      : ''}
`;

export const ResetWrapper = styled.div`
  text-align: right;
  :hover {
    cursor: pointer;
  }
`;

export const WrapperControl = styled.div`
  height: 100%;

  .Select__control {
    
    ${props =>
      props.variant === 'editaccountdata' &&
      css`
        padding: ${pxToRem('16px')};

        &:hover {
          border-color: ${props => props.theme.colors.mainBlue};
        }
      `}
    
    ${props =>
      props.paginationMenu &&
      css`
        padding: 0;
      `}
    
    ${props =>
      !props.paginationMenu &&
      props.variant !== 'editaccountdata' &&
      css`
        padding: ${pxToRem('4px')} ${pxToRem('32px')};
      `}
    
    ${props =>
      props.hasValue &&
      !props.paginationMenu &&
      css`
        opacity: 1;
      `}
    
    
    ${props =>
      !props.hasValue &&
      !props.paginationMenu &&
      props.variant === 'editaccountdata' &&
      css`
        opacity: 0.4;
      `};
  }
`;

export const IconInfo = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${pxToRem('45px')};
  div {
    position: absolute;
    top: ${pxToRem('13px')};
    right: ${pxToRem('55px')};
  }
`;
